"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.capitalizeWords = void 0;

var capitalize = function capitalize(string) {
  if (typeof string !== 'string') {
    return '';
  }

  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

var capitalizeWords = function capitalizeWords(string) {
  if (typeof string !== 'string') {
    return '';
  }

  return string === null || string === void 0 ? void 0 : string.split(' ').map(function (element) {
    return capitalize(element);
  }).join(' ');
};

exports.capitalizeWords = capitalizeWords;
var _default = capitalize;
exports["default"] = _default;
//# sourceMappingURL=capitalize.js.map